<script setup lang="ts">
import { AppStandardModal } from '@libs/ui';

import { useHotelDetailsDescriptionStore } from '../../stores';
import HotelMainDescription from '../description/HotelMainDescription.vue';

interface FullHotelDetailsDescriptionModalEmits {
  (eventName: 'close'): void;
}

const emit = defineEmits<FullHotelDetailsDescriptionModalEmits>();

const hotelDetailsDescriptionStore = useHotelDetailsDescriptionStore();
</script>

<template>
  <AppStandardModal @close="emit('close')">
    <template #title>
      {{ $t('planner.about_the_hotel') }}
    </template>
    <template #body>
      <HotelMainDescription
        v-if="hotelDetailsDescriptionStore.fullMainDescription"
        :description="hotelDetailsDescriptionStore.fullMainDescription"
      />
    </template>
  </AppStandardModal>
</template>
